// Sprint History — quality output per sprint, most recent first.
// Ported from qa-live (QA-2286), dark-theme inline styles.

import { PULSE_COLORS } from './pulseConfig.js'

function fmtDate(iso) {
    if (!iso) return ''
    const d = new Date(iso)
    if (isNaN(d.getTime())) return ''
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
}

function pct(part, whole) {
    if (!whole) return '—'
    return `${Math.round((part / whole) * 100)}%`
}

const COLS = [
    { key: 'bugs', label: 'Bugs', emoji: '🐛' },
    { key: 'closed', label: 'Closed', emoji: '✅' },
    { key: 'stories', label: 'Stories', emoji: '📋' },
    { key: 'ai', label: 'AI', emoji: '🤖' },
    { key: 'aiPct', label: 'AI %', emoji: '✨' },
    { key: 'defectRate', label: 'Defects/Story', emoji: '📈' },
]

export default function QaSprintHistory({ sprints, limit = 12, headerAction }) {
    const rows = [...sprints]
        .filter((s) => s.completedCount > 0 || s.bugsInSprint > 0)
        .sort((a, b) => b.sprintNumber - a.sprintNumber)
        .slice(0, limit)

    const th = {
        textAlign: 'right',
        fontWeight: 500,
        fontSize: '12px',
        padding: '8px',
        whiteSpace: 'nowrap',
        color: PULSE_COLORS.textSubtle,
    }
    const td = { textAlign: 'right', padding: '8px', fontVariantNumeric: 'tabular-nums', color: PULSE_COLORS.text }

    return (
        <div
            style={{
                background: PULSE_COLORS.cardBg,
                borderRadius: '12px',
                padding: '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                }}
            >
                <div>
                    <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                        🗓️ Sprint History
                    </h3>
                    <p style={{ marginTop: '2px', fontSize: '11px', color: PULSE_COLORS.textMuted }}>
                        Quality output per sprint — most recent first
                    </p>
                </div>
                {headerAction}
            </div>

            {rows.length === 0 ? (
                <p style={{ fontSize: '13px', color: PULSE_COLORS.textMuted }}>No sprint history available.</p>
            ) : (
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead>
                            <tr>
                                <th style={{ ...th, textAlign: 'left', paddingRight: '12px' }}>Sprint</th>
                                {COLS.map((col) => (
                                    <th key={col.key} style={th}>
                                        {col.emoji} {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((s) => {
                                const defectRate = s.completedCount ? s.bugsInSprint / s.completedCount : 0
                                const hot = defectRate > 0.5
                                return (
                                    <tr key={s.sprintNumber} style={{ borderTop: `1px solid ${PULSE_COLORS.border}` }}>
                                        <td style={{ padding: '8px', paddingRight: '12px', whiteSpace: 'nowrap' }}>
                                            <span style={{ fontWeight: 600, color: PULSE_COLORS.text }}>
                                                S{s.sprintNumber}
                                            </span>
                                            {s.endDate && (
                                                <span
                                                    style={{
                                                        marginLeft: '8px',
                                                        fontSize: '11px',
                                                        color: PULSE_COLORS.textSubtle,
                                                    }}
                                                >
                                                    {fmtDate(s.endDate)}
                                                </span>
                                            )}
                                        </td>
                                        <td style={td}>{s.bugsInSprint}</td>
                                        <td style={td}>{s.bugsCompleted}</td>
                                        <td style={td}>{s.completedCount}</td>
                                        <td style={td}>{s.aiCompletedCount}</td>
                                        <td style={{ ...td, fontWeight: 500, color: '#22D3EE' }}>
                                            {pct(s.aiCompletedPoints, s.completedPoints)}
                                        </td>
                                        <td
                                            style={{
                                                ...td,
                                                fontWeight: 500,
                                                color: hot ? '#F87171' : PULSE_COLORS.text,
                                            }}
                                        >
                                            {defectRate.toFixed(2)}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}
